module.exports = __webpack_public_path__ + "img/v_2.648829e5.svg";